'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'solar-system';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e02f';
var svgPathData = ['M69.3 69.3a24 24 0 1 0 33.9 33.9 24 24 0 1 0 -33.9-33.9zM224 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM408.7 408.7a24 24 0 1 0 33.9 33.9 24 24 0 1 0 -33.9-33.9z', 'M163.9 17.1c7.5 8.4 13.4 17.7 17.7 27.6 23.3-8.2 48.3-12.6 74.4-12.6 123.7 0 224 100.3 224 224 0 43.2-12.2 83.5-33.4 117.7-20.2-8.1-44.1-4-60.5 12.4-21.9 21.9-21.9 57.3 0 79.2s57.3 21.9 79.2 0c19.4-19.4 21.6-49.6 6.5-71.5 25.5-39.8 40.2-87.1 40.2-137.8 0-141.4-114.6-256-256-256-32.5 0-63.5 6-92.1 17.1zM330.4 467.4c-23.3 8.2-48.3 12.6-74.4 12.6-123.7 0-224-100.3-224-224 0-43.2 12.2-83.5 33.4-117.7 20.2 8.1 44.1 4 60.5-12.4 21.9-21.9 21.9-57.3 0-79.2s-57.3-21.9-79.2 0c-19.4 19.4-21.6 49.6-6.5 71.5-25.5 39.8-40.2 87.1-40.2 137.8 0 141.4 114.6 256 256 256 32.5 0 63.5-6 92.1-17.1-7.5-8.4-13.4-17.7-17.7-27.6zM384 256c0 70.7-57.3 128-128 128s-128-57.3-128-128 57.3-128 128-128c22.9 0 44.4 6 63 16.5-3.2 13.2 .3 27.6 10.5 37.9s24.8 13.8 37.9 10.5C378 211.6 384 233.1 384 256zm9-82.7c8.2-15.2 6-34.6-6.9-47.4s-32.2-15.1-47.4-6.9c-24.1-14.6-52.5-23-82.7-23-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160c0-30.3-8.4-58.6-23-82.7zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM103.3 69.3a24 24 0 1 1 -33.9 33.9 24 24 0 1 1 33.9-33.9zM408.7 408.7a24 24 0 1 1 33.9 33.9 24 24 0 1 1 -33.9-33.9z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSolarSystem = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;